import { useEffect, useState } from 'react';

export const STORE_PLATFORMS = {
    IOS: 'ios',
    ANDROID: 'android',
};

function detectStorePlatform() {
    if (typeof navigator === 'undefined') {
        return null;
    }

    const platform = navigator.userAgentData?.platform || navigator.platform || '';
    const userAgent = navigator.userAgent || '';
    const normalizedPlatform = platform.toLowerCase();
    const normalizedUserAgent = userAgent.toLowerCase();

    if (normalizedPlatform.includes('iphone') || normalizedPlatform.includes('ipad') || normalizedUserAgent.includes('iphone') || normalizedUserAgent.includes('ipad') || normalizedUserAgent.includes('ipod')) {
        return STORE_PLATFORMS.IOS;
    }

    if (normalizedPlatform.includes('android') || normalizedUserAgent.includes('android')) {
        return STORE_PLATFORMS.ANDROID;
    }

    return null;
}

export function useStorePlatform() {
    const [platform, setPlatform] = useState(null);

    useEffect(() => {
        setPlatform(detectStorePlatform());
    }, []);

    return platform;
}
